var _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 431.03,
    height: 560,
    viewBox: "0 0 431.03 560",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "qelq7d3u7a"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 333",
    cx: 106.955,
    cy: 106.955,
    r: 106.955,
    transform: "matrix(.163 -.987 .987 .163 0 211.046)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3018"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 726",
    style: {
      fill: "none"
    },
    d: "M0 0h431.03v560H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2118",
    transform: "translate(-214.177 -120.275)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 328",
    cx: 20.607,
    cy: 35.695,
    rx: 20.607,
    ry: 35.695,
    transform: "rotate(-89.689 461.343 -51.12)",
    style: {
      fill: "#3581d8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 329",
    cx: 20.607,
    cy: 35.695,
    rx: 20.607,
    ry: 35.695,
    transform: "rotate(-89.71 435.592 127.193)",
    style: {
      fill: "#3581d8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 330",
    cx: 26.372,
    cy: 45.679,
    rx: 26.372,
    ry: 45.679,
    transform: "rotate(-89.689 513.871 58.029)",
    style: {
      fill: "#3581d8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 331",
    cx: 22.789,
    cy: 39.473,
    rx: 22.789,
    ry: 39.473,
    transform: "rotate(-89.689 358.864 88.473)",
    style: {
      fill: "#3581d8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2157"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2070",
    d: "m346.057 229.069-52.074-30.063a8.164 8.164 0 0 1-4.08-7.07v-51.27a4.106 4.106 0 0 1 6.159-3.556l52.074 30.065a8.163 8.163 0 0 1 4.08 7.068v51.27a4.106 4.106 0 0 1-6.159 3.556z",
    transform: "translate(62.892)",
    style: {
      fillRule: "evenodd",
      fill: "#3581d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2071",
    d: "m294.078 200.469-24.129-13.931a3.784 3.784 0 0 1-1.891-3.275v-23.757a1.9 1.9 0 0 1 2.854-1.649l24.131 13.931a3.784 3.784 0 0 1 1.891 3.275v23.759a1.9 1.9 0 0 1-2.856 1.647z",
    transform: "translate(43.717 18.473)",
    style: {
      fillRule: "evenodd",
      fill: "#3581d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2072",
    d: "m434.262 291.511-37.681-21.756a5.906 5.906 0 0 1-2.954-5.117v-37.1a2.971 2.971 0 0 1 4.458-2.573l37.683 21.756a5.906 5.906 0 0 1 2.952 5.115v37.1a2.972 2.972 0 0 1-4.458 2.575z",
    transform: "translate(153.936 77.25)",
    style: {
      fillRule: "evenodd",
      fill: "#3581d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2073",
    d: "m393.956 241.54 50.836-29.349a7.971 7.971 0 0 0 3.985-6.9v-50.054a4.01 4.01 0 0 0-6.014-3.472l-50.836 29.351a7.968 7.968 0 0 0-3.985 6.9v50.053a4.009 4.009 0 0 0 6.014 3.471z",
    transform: "translate(148.946 12.875)",
    style: {
      fillRule: "evenodd",
      fill: "#3581d8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2120"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2074",
    d: "m226.869 342.828 72.838-42.052a11.419 11.419 0 0 0 5.708-9.888v-71.715a5.745 5.745 0 0 0-8.615-4.973l-72.84 42.051a11.419 11.419 0 0 0-5.708 9.888v71.715a5.744 5.744 0 0 0 8.617 4.974z",
    transform: "translate(0 67.47)",
    style: {
      fillRule: "evenodd",
      fill: "#3581d8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2118"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2075",
    d: "M246.759 271.734a29.264 29.264 0 0 1-3.908 2.717c-6.677 3.853-12.553 3.335-15.978-.627l15.978-21.352z",
    transform: "translate(7.568 101.747)",
    style: {
      fill: "#ec827d",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2076",
    d: "M254.536 252.923c0 10.6-6.544 23.22-15.245 30.318l-3.908-19.262v-21.987c10.576-6.106 19.153-1.217 19.153 10.931z",
    transform: "translate(15.036 90.24)",
    style: {
      fill: "#fbd15b",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2077",
    d: "M244.34 240.763v21.987l-15.977 21.35c-2.017-2.317-3.185-5.812-3.185-10.288 0-12.144 8.578-26.937 19.162-33.049z",
    transform: "translate(6.079 91.47)",
    style: {
      fill: "#56548c",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2119"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2078",
    d: "m273.948 233.991-25.713 14.394v-3.666l25.713-14.394z",
    transform: "translate(26.318 82.308)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2079",
    d: "m273.948 241.613-25.713 14.394v-3.666l25.713-14.394z",
    transform: "translate(26.318 88.998)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2080",
    d: "m273.948 249.236-25.713 14.394v-3.666l25.713-14.394z",
    transform: "translate(26.318 95.689)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2154"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2121",
    transform: "translate(399.593 439.377)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 332",
    cx: 18.491,
    cy: 32.028,
    rx: 18.491,
    ry: 32.028,
    transform: "rotate(-89.689 25.204 25.067)",
    style: {
      fill: "#56548c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2081",
    d: "m325.163 302.544-9.658 17.877 62.052 1.026-9.626-17.977z",
    transform: "translate(-314.228 -293.679)",
    style: {
      fill: "#56548c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2082",
    d: "M358.115 319.778c-8.662 5-22.747 4.974-31.462-.056s-8.76-13.165-.1-18.165 22.745-4.974 31.46.058 8.762 13.162.102 18.163z",
    transform: "translate(-310.206 -297.823)",
    style: {
      fill: "#878cf0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2083",
    d: "M351.483 315.949c-6.467 3.733-16.984 3.714-23.493-.041s-6.54-9.83-.073-13.565 16.984-3.714 23.493.043 6.54 9.83.073 13.563z",
    transform: "translate(-307.573 -296.302)",
    style: {
      fill: "#bee1f4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2084",
    d: "M354.046 345.468c.161-1.316-66.226-87.293-66.226-87.293h174.12l-74.7 87.776z",
    transform: "translate(61.063 106.753)",
    style: {
      opacity: 0.5,
      fill: "#bee1f4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2124"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2123"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2122"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2085",
    d: "M392.933 260.526s-12.746 14.892-16.145 15.891-.334 4.5 2.276 4.769 10.906-.086 13.325-2.464 9.254-4.92 9.254-4.92a38.53 38.53 0 0 0-1.848-12.575z",
    transform: "translate(137.836 108.817)",
    style: {
      fill: "#606bf1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2086",
    d: "M382.854 205.67s-1.65 32.958-1.048 43.765 3.239 64.456 3.239 64.456c6.978 1.5 11.413 0 11.413 0 2.295-41.138 2.229-52.968 2.886-59.1s1.472-23.868 1.472-23.868c4.92-10.179-.227-23.427-2.653-26.617s-15.309 1.364-15.309 1.364z",
    transform: "translate(143.444 58.473)",
    style: {
      fill: "#112b46",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2087",
    d: "M397.315 268.459c-.428 6.024-2.6 13.122-3.155 16.733a8.554 8.554 0 0 0 1.577 6.82c.832 1.16 11.019-2.208 12.41-6.133s-1.461-7.361-1.681-14.72c-3.291-5.889-9.151-2.7-9.151-2.7z",
    transform: "translate(154.287 115.023)",
    style: {
      fill: "#606bf1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2088",
    d: "M387.942 207.061s1.754 30 4.52 39.989 5.248 39.3 6.426 44.407 2.614 36.68 2.614 36.68a22.489 22.489 0 0 0 11.319 0c-.133-29.565.582-53.595 0-61.7s.231-32.14.231-32.14c2.625-11.186 2.781-12.615 0-20.045s-14.732-13.325-25.11-7.191z",
    transform: "translate(148.946 59.642)",
    style: {
      fill: "#112b46",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2089",
    d: "M406.46 167.951c-10.354 2.914-15.912 28.934-18.813 34.778s-27.072 7.3-27.072 7.3c-1.451 5.07 2.659 10.388 2.659 10.388 23.28-.967 31.494-2.9 35.809-12.085s19.463-37.251 7.417-40.381z",
    transform: "translate(124.652 27.559)",
    style: {
      fill: "#112b46",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2090",
    d: "M388.333 167.962c9.2-.406 30.514 4.375 37.533 13.328s-3.172 24.775-5.611 34.308 1.127 33.473 1.121 35.769c-10.895 7.226-37.136 8.14-40.082-2.634-1.217-11.727 1.47-25.648 1.615-32.508-.354-14.734-6.749-43.899 5.424-48.263z",
    transform: "translate(142.779 27.548)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2091",
    d: "M396.552 170.14c-5.922 20.787-7.314 44.112-6.739 52.936s.817 37.345.817 37.345c-6.888-3.626-9.909-10.273-9.909-13.294s2.593-28.835 2.511-30.912-3.478-25.77-2.511-36.406 7.935-11.858 7.935-11.858h8.863z",
    transform: "translate(142.456 27.559)",
    style: {
      fill: "#112b46",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2092",
    d: "M386.872 155.752c-4.05 1.277 0 10.487 0 10.487z",
    transform: "translate(146.427 16.851)",
    style: {
      fill: "#56548c",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2093",
    d: "M386.423 160.266s-1.527 5.391-.95 9.58.954 12.534 4.666 15.2 9.034-.43 12.558-3.421a20.939 20.939 0 0 0 7.342-15.187c.085-6.675-2.527-14.855-12.153-14.438s-11.463 8.266-11.463 8.266z",
    transform: "translate(146.665 13.548)",
    style: {
      fill: "#ffc8af",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2094",
    d: "M402.2 164.619s-.751 8.594 1.5 11.766c.161 2.114-5.9 11.079-11.933 9.513-3.513-.911-3.093-5.006-3.093-5.006a96.5 96.5 0 0 0 0-10.683z",
    transform: "translate(149.579 24.634)",
    style: {
      fill: "#ffc8af",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2095",
    d: "M384.886 155.6c-1.371 4.95.193 6.728 4.366 8.148s15.272-1.8 15.272-1.8c-.751 5.3.918 8.048.918 8.048 1.835-5.207 3.5-2.556 3.671 1.609s-2.169 4.071-2.169 4.071c.167 3.5 1.294 4.694 1.294 4.694 4.463-3.085 10.54-23.714 2.5-24.191-.123-7.201-22.915-11.179-25.852-.579z",
    transform: "translate(145.839 11.018)",
    style: {
      fill: "#56548c",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2096",
    d: "M401.862 170.155c-7.156 15.092-10.9 28.869-10.662 41.318s2.813 48.705 2.813 48.705c12.416-3.021 20.875-6.525 23.294-10.756-5.318-14.019-7.252-23.447-6.165-27.436s10.467-34.395 5.6-43.423c-4.633-5.039-14.88-8.408-14.88-8.408z",
    transform: "translate(151.796 29.493)",
    style: {
      fill: "#112b46",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2097",
    d: "M406.2 173.44c8.559 4.261 14.74 24.726 21.267 31.054 3.7 3.587 21.968 8.268 27.043 8.4 1.966 4.478-1.57 9.458-1.57 9.458-31.182-2.927-32.56-4.644-42.152-16.881-11.904-15.195-16.043-34.96-4.588-32.031z",
    transform: "translate(159.035 32.121)",
    style: {
      fill: "#112b46",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2098",
    d: "M401.031 169.084a17.615 17.615 0 0 0 1.6 2.011s-3.1 6.784-4.223 9.779a15.89 15.89 0 0 1-4.062 5.494l-4.024-4.39c5.541-2.934 10.709-12.894 10.709-12.894z",
    transform: "translate(151.032 28.553)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2099",
    d: "M429 196a31.264 31.264 0 0 1 7.582-1.142c3.262.081 6.523-.978 7.177-.9s.407 2.527-4.078 3.1c3.752.978 6.933 1.632 9.133.9s1.957 2.283 0 4.321-5.138 2.366-7.338 2.61-10.846-1.386-13.454-2.447c-.901-5.053.978-6.442.978-6.442z",
    transform: "translate(183.91 50.388)",
    style: {
      fill: "#ffc8af",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2100",
    d: "M389.833 170.245c.368-.458 1.251 8.469 2.588 10.729a16.371 16.371 0 0 1-4.112 3.078s-1.537-9.991 1.524-13.807z",
    transform: "translate(148.929 29.558)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2101",
    d: "m392.11 175.854-3.436 2.107a20.619 20.619 0 0 1 .839 4.565h3.213l2.39-3.412z",
    transform: "translate(149.589 34.496)",
    style: {
      fill: "#fbd15b",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2102",
    d: "M391.133 179.678c-4.779 24.79-4.291 40.12-4.291 40.12l2.426 6.82 5.239-7.637s-3.795-29.124-.161-39.3c-1.99-1.306-3.213-.003-3.213-.003z",
    transform: "translate(147.969 37.344)",
    style: {
      fill: "#fbd15b",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2126"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2103",
    d: "M272.313 187.649s16.015 11.327 22.723 15.084 32.909-10.99 32.909-10.99 3.56 1.829 1.994 7.513c-17.151 11.556-29.8 17.024-34.9 15.869s-20.49-10.177-25.7-12.953-4.162-15.182 2.974-14.523z",
    transform: "translate(41.972 44.826)",
    style: {
      fill: "#ec827d",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2125"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2104",
    d: "M267.833 284.847c.325 4.634.753 9.265.753 9.265h1.029s0-7.006 1.1-5.532c-.155-3.816-2.882-3.733-2.882-3.733z",
    transform: "translate(43.521 130.164)",
    style: {
      fill: "#112b46",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2105",
    d: "M283.4 325.006c.5 0 1.166-.539 1.759-1.35-1.05-1.254-2.094-2.482-2.788-3.446-2.229-3.093-5.83-9.954-6-13.041s1.716-35.332 2.231-39.277 1.992-18.868 1.853-19.724-13.862 5.3-13.862 5.3c.173 1.219 2.028 8.936 1.271 13.91s-1.957 8.26-1.271 16.393 4.632 21.168 3.26 27.344c-.024.111-.043.208-.068.315 4.036 5.534 5.455 16.297 13.615 13.576z",
    transform: "translate(42.254 97.898)",
    style: {
      fill: "#ffc8af",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2106",
    d: "M283.918 294.046c-.593.811-1.264 1.35-1.759 1.35-8.163 2.721-9.582-8.042-13.617-13.576-1.279 5.87-.71 6.561.357 7.4 1.083.858 4.858 5.489 5.543 8.748s10.977 2.914 12.865 2.229c1.293-.471-1.064-3.378-3.389-6.151z",
    transform: "translate(43.498 127.507)",
    style: {
      fill: "#112b46",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2107",
    d: "M265.864 278.75c-.4 3.609-2.511 31.394-2.167 36.032.2 2.826 1.549 7.272 2.387 10.838.535 2.265.851 4.185.535 5.106-.822 2.374-.864 9.44-4.693 7.847s-6.381-6.516-5.6-11.963c.768-5.447-.152-8.069.068-11.321s-1.962-23.5-2.3-30.694c-.344-7.218 2.058-10.649 2.236-15.45.163-4.8-1.277-14.819-1.277-14.819s16.534-8.671 15.176 1.784-3.967 19.044-4.365 22.64z",
    transform: "translate(31.431 100.412)",
    style: {
      fill: "#ffc8af",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2108",
    d: "M251.5 225.33c-2.25 11.321 3.11 18.866 4.1 21.436s-2.154 34.645-2.154 34.645c8.692 13.379 39.055 5.147 44.028-3.258-.68-19.765-2.388-52.141-2.225-55.572S251.5 225.33 251.5 225.33z",
    transform: "translate(28.705 74.601)",
    style: {
      fill: "#56548c",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2109",
    d: "M266.3 296.079c-.257 4.83-1.544 9.182-5.372 7.59s-6.381-6.516-5.6-11.963c2.058 6.009 9.92 5.748 9.755-.99.541 2.265 1.272 4.392 1.217 5.363z",
    transform: "translate(32.425 135.316)",
    style: {
      fill: "#112b46",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2110",
    d: "M270.817 167.8c5.231 4.985 6.972 9.334 6.212 14.228s-1.632 11.09.869 12.938c-5.327 4.131-15.414-1.848-15.21-2.935s5.613-16.853 6.116-16.962z",
    transform: "translate(39.002 27.426)",
    style: {
      fill: "#56548c",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2111",
    d: "M288.076 188.947c-11.2-5.611-30.436-2.362-37.955 5.887s8.283 23.509 10.9 32.3-15.407 33.426-9.464 40.978c11.668 6.657 45.3 2.116 48.452-7.811-.116-14.729-8.912-27.62-6.816-33.736.111-3.928 5.738-16.744 3.485-21.7-4.603-10.101-3.604-12.837-8.602-15.918z",
    transform: "translate(26.209 43.528)",
    style: {
      fill: "#d16565",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2112",
    d: "M279.728 175.214s1.527 5.391.952 9.58-.954 12.534-4.666 15.2-9.034-.43-12.558-3.421a20.941 20.941 0 0 1-7.344-15.187c-.083-6.675 2.527-14.855 12.155-14.436s11.461 8.264 11.461 8.264z",
    transform: "translate(33.23 26.67)",
    style: {
      fill: "#ffc8af",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2113",
    d: "M260.543 181.5s.623 8.6-1.247 11.768c-.133 2.112 4.9 11.079 9.905 9.513 2.918-.913 2.567-5.008 2.567-5.008-.312-3.126 0-10.681 0-10.681z",
    transform: "translate(36.025 39.454)",
    style: {
      fill: "#ffc8af",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2114",
    d: "M273.5 175.091a12.373 12.373 0 0 1-7.99 8.478c-.978 9.133 1.179 15.612 4.133 17.039-7.973 2.9-12.6.678-14.778-3.607s-3.87-22.563 5.1-28.108 13.535 6.198 13.535 6.198z",
    transform: "translate(30.62 27.079)",
    style: {
      fill: "#56548c",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2115",
    d: "M268.1 176.064c2.773 3.75 8.906 3.913 9.916 3.75-.131-14.515-14.156-15.982-18.723-10.763 3.752 7.175 8.807 7.013 8.807 7.013z",
    transform: "translate(36.024 26.106)",
    style: {
      fill: "#56548c",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2117",
    d: "M259.465 221.682c.548-.244-2.717-26.088-2.717-26.088l22.77-4.5.976 39.906-20.652 4.831z",
    transform: "translate(33.79 47.869)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2118",
    d: "M264.671 208.193s7.259-7.077 8.869-8.707 1.59.556-.5 4.355c3.271.768 5.367 5.153 5.6 6.687s-3.919 5.492-5.1 5.958-6.031 0-6.031 0z",
    transform: "translate(40.745 54.759)",
    style: {
      fill: "#ffc8af",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2119",
    d: "M254.946 189.83c6.214.445 7.214 34.076 7.214 34.076s17.009-7.909 18.19-7.7c6.3 1.369 2.837 8.292 2.837 8.292-13.313 10.112-18.695 15.923-25.194 14.673s-11.411-24.493-11.178-34.973 4.196-14.648 8.131-14.368z",
    transform: "translate(25.065 46.752)",
    style: {
      fill: "#ec827d",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2144"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2127"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2120",
    d: "M488.887 272.136a106.845 106.845 0 0 1-104.758 106.938c-.734.011-1.468.023-2.2.023s-1.468 0-2.2-.023a106.954 106.954 0 1 1 109.158-106.938z",
    transform: "translate(49.793 25.134)",
    style: {
      fill: "#85cded"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2128"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2121",
    d: "M480.555 257.869a107.014 107.014 0 0 1-99.08 72.457c-.734.011-1.468.023-2.2.023s-1.468 0-2.2-.023A106.988 106.988 0 0 1 278 257.869c14.35-21.611 54.267-37.142 101.271-37.142s86.934 15.531 101.284 37.142z",
    transform: "translate(52.446 73.883)",
    style: {
      fill: "#8fd7ef"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2143"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2142",
    style: {
      clipPath: "url(#qelq7d3u7a)"
    },
    transform: "translate(308.757 174.31)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2134"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2129"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2122",
    d: "M273.313 251.96c-.188-17.18 11.218-33.287 32.117-45.352 42.721-24.664 112.451-24.54 155.442.28 20.837 12.031 32.414 28.031 32.6 45.053l-1.144.011c-.182-16.6-11.556-32.252-32.029-44.073-42.676-24.638-111.893-24.764-154.3-.28-20.524 11.849-31.726 27.6-31.544 44.349z",
    transform: "translate(-260.429 -128.986)",
    style: {
      fill: "#bee1f4"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2130"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2123",
    d: "M322.82 366.393a40.276 40.276 0 0 1-19.878-4.955l.558-1c14.329 8 33.364 5.968 53.6-5.712 42.3-24.424 76.716-83.782 76.716-132.32 0-24.435-8.964-42.723-24.593-50.177l.492-1.033c16.044 7.652 25.244 26.317 25.244 51.21 0 48.9-34.671 108.7-77.286 133.309-12.286 7.093-24.156 10.678-34.853 10.678z",
    transform: "translate(-234.42 -143.902)",
    style: {
      fill: "#bee1f4"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2132"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2131"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2124",
    d: "M402.757 366.393c-10.7 0-22.565-3.585-34.847-10.677-42.618-24.6-77.287-84.407-77.287-133.309 0-24.893 9.2-43.558 25.244-51.21l.492 1.033c-15.629 7.455-24.593 25.742-24.593 50.177 0 48.538 34.414 107.9 76.716 132.32 20.235 11.682 39.271 13.711 53.6 5.712l.558 1a40.277 40.277 0 0 1-19.883 4.954z",
    transform: "translate(-245.233 -143.902)",
    style: {
      fill: "#bee1f4"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2133"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2125",
    d: "M383.238 311.08c-60.516 0-109.751-39.9-109.751-88.934h1.145c0 48.407 48.72 87.789 108.605 87.789s108.605-39.382 108.605-87.789h1.145c.002 49.038-49.233 88.934-109.749 88.934z",
    transform: "translate(-260.274 -99.181)",
    style: {
      fill: "#bee1f4"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2135"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2126",
    d: "M344.8 370.581c1.561-.314-.156-2.963 2.651-2.651s9.667 2.445 12.474.6-1.872-4.03 1.4-4.965 6.371-2.629 6.861-4.677.623-3.431-1.872-3.9-4.989-3.119-7.171-3.742-6.082-.312-8.42-1.714-7.952-6.082-10.136-6.238-6.859 0-4.522-.779 4.054-.623 2.963-1.714-3.742-6.238-5.613-7.641-7.017-2.651-9.355-5.613-5.459-9.669-5.459-9.669-6.7-1.87-9.043-4.833-4.677-5.924-6.08-6.236-2.651-1.4-3.587-1.56-1.558 1.4-2.651 2.028-2.182-2.028-2.805-4.054-2.807-1.247-3.742-2.963-1.872-5.145-1.716-6.236 1.872-4.677 1.4-6.394-3.119-3.586-3.9-5.3 1.091-4.833 2.182-6.392 2.34-1.872.779-3.275-3.487-1.56-3.147 0-1.374 1.987-2.621-1.112-1.714-10.427.779-13.234.937-6.392 3.742-5.768 3.431 2.807 4.054 4.989 1.872 2.651 1.716-.468c2.961 3.587 2.805 5.613 3.273 6.082s1.093.468 1.093 1.4-.781 4.989-.625 7.173 0 4.21.937 3.9 1.714-4.523 1.714-7.173.623-5.457 2.026-5.613 2.807-1.56 4.523-1.249 4.052-.623 4.522-2.338 5.924-6.848 7.483-6.777 2.963 2.255 4.366 1.943-.261-3.9 2.287-4.21 5.042-1.093 5.509 0-3.119 1.714-2.026 2.494 3.117-.623 4.522-.468 5.3 1.4 5.457-.156.468-3.463-.779-2.434-1.091 2.434-2.028 1.187-2.026-1.451-1.714-3.3 2.651-3.718 2.026-4.186-4.054-.623-4.522-1.247 1.4-2.5 4.054-1.872 4.21 2.807 5.926 2.651 4.21-2.651 4.21-.935-3.119 4.161-3.587 5.588.312 2.206 2.494 2.832 2.028 2.805 3.275 2.182 2.028-5.3.623-6.08-3.117 1.87-2.026-1.4 3.431-3.74 2.494-6.7-2.805-6.394-2.805-7.641 1.4-7.8 1.4-7.8-2.026 2.34-3.431 1.872-2.338-1.4-1.559-2.5 2.651-2.963 2.182-3.119a1.814 1.814 0 0 1-1.091-1.714c0-.935-.935-2.028-1.4-2.651s-.468-1.559-1.247-1.4-2.028 2.184-2.5 3.431-3.119 1.559-3.119 2.65.312 4.21-2.338 4.679-4.054 0-4.522.779-2.445 5.457-3.483 5.145-.52-2.184 0-4.21 2.39-1.559 2.079-3.587-1.4-1.091-1.091-2.963-1.352-4.522-.988-5.3 1.923-.935 1.767-2.182.312-4.991 3.431-5.145 9.2-1.249 10.446-1.872a2.83 2.83 0 0 1 2.963 0c.623.468.623.424 2.028-.411s5.924-3.331 6.548-2.708 0 4.21-1.4 5.614-2.34 3.273-3.431 2.961-3.9-2.026-3.119-.779 2.807 1.714 2.807 2.651-.779 4.833.312 5.457 1.247-2.184 1.714-2.338.156 3.273 1.249 2.182 1.559-4.21 1.714-5.457-.623-1.56.156-1.249 0 3.431 1.4 3.431 4.522-.468 3.273-2.182-1.87-4.522-1.4-4.833a2.145 2.145 0 0 0 1.247-1.716c0-.935 1.56-5.3-.623-5.924s-3.431.779-2.182-.623a8.787 8.787 0 0 0 1.714-3.275s-3.275-.468-4.989 1.559-1.247 2.651-1.716 2.963-3.74 2.5-4.21 1.714 2.651-2.494 2.963-2.961 1.716-4.366 2.184-4.522-5.147 2.65-6.55 3.9-4.054 1.716-3.742 1.249 8.108-3.742 6.238-4.366-5.3 2.182-5.926.935 1.093-.481.467-1.722-2.805.631-2.338-1.553-.468-2.649.935-2.805 1.559-1.4 2.651-3.275 1.247-6.861 2.494-7.017 9.824-4.522 10.6-6.392 3.586-3.587.468-2.963-5.926 1.714-5.457 1.091.156-2.287-2.5-1.221-11.383 3.56-11.85 5.119 1.093 1.716-4.366 5.3-10.134 8.576-12.63 10.136-2.182 3.273-4.366 4.21-2.65.312-4.522 2.65-9.2 7.485-10.6 9.669-8.887 11.225-13.253 23.387-6.861 23.7-6.706 26.506-.312 13.253.935 15.125a18.372 18.372 0 0 1 2.651 7.952c.312 3.117 2.807 4.833 3.587 6.7s.312 6.08.468 7.329 3.9 8.108 4.21 9.2.935-1.247 1.559 0a18.234 18.234 0 0 1 2.028 7.641c0 3.273-4.21 3.431-3.119 6.392s11.539 20.27 15.9 26.506 15.9 16.372 19.333 18.4z",
    transform: "translate(-255.029 -145.042)",
    style: {
      fill: "#bee1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2127",
    d: "M299.636 241.994c.329 1.861-8.185-3.275-8.653-4.794s3.742 2.221 3.273.584-1.87-3.04-.935-3.275 5.964 5.496 6.315 7.485z",
    transform: "translate(-244.948 -88.336)",
    style: {
      fill: "#bee1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2128",
    d: "M295.6 240.033c-1.354-.56-4.21-1.053-3.742-2.924s-2.573-7.134-3.391-8.185-2.807-2.456-1.87-2.691 2.221 1.4 3.859 3.275 5.261 8.42 5.964 9.355 1.88 2.285-.82 1.17z",
    transform: "translate(-248.982 -95.614)",
    style: {
      fill: "#bee1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2129",
    d: "M327.772 220.289c.062-1.219 1.053-2.689-.7-2.807s-3.275 4.8-3.158-3.04.546-10.992 2.028-11.811 1.3-1.87 2.034-3.275-.9-1.87.5-4.794.468-5.613 0-7.25.935-3.275 3.626-4.093 4.91-.7 7.015-1.17 1.754-2.221 3.626-1.286 2.689 4.21 4.326 2.924 2.34-.468 1.872.7-1.236 2.572.141 3.975.911 3.51 1.262 5.847-2.221.351-2.456 1.872 1.872 2.184 2.456 4.308.584 4.112-1.754 4.7-6.082-1.17-6.9.468-2.956 3.508-4.4 4.677-1.444-.351-2.614 1.521-4.572 7.485-5.211 8.069-1.757 1.736-1.693.465z",
    transform: "translate(-216.017 -135.744)",
    style: {
      fill: "#bee1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2130",
    d: "M315.774 187.7c-.907 1.382-3.391.118-2.924-1.754s-1.636-3.975 1.17-4.443 2.807 1.286 3.859-.586a6.23 6.23 0 0 1 2.924-2.572s3.509-2.805 2.691-.349-6.644 8.067-7.72 9.704z",
    transform: "translate(-226.004 -138.821)",
    style: {
      fill: "#bee1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2131",
    d: "M324.158 185.78c-1.314-.22-3.742-1.17 0-2.34s8.771-5.38 10.992-4.561.937 3.121.937 3.121-8.42 4.364-11.929 3.78z",
    transform: "translate(-217.548 -137.251)",
    style: {
      fill: "#bee1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2132",
    d: "M342.534 201.41c-4.371 1.821-5.9-5.847-4-5.38s3.534-1.87 5.639-.233 1.168 4.443-1.639 5.613z",
    transform: "translate(-203.883 -122.828)",
    style: {
      fill: "#bee1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2133",
    d: "M348.477 186.909c-4.319-1.774-5.964-2.805-5.613-3.624s-.7-4.963 1.87-2.189 4.4 6.083 3.743 5.813z",
    transform: "translate(-199.417 -136.043)",
    style: {
      fill: "#bee1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2134",
    d: "M454.951 273.564c0-.58-1.525-1.048-2.1 1.758s1.048 6.662-1.758 5.838-4.088-3.275-5.145-4.677a41.025 41.025 0 0 0-2.685-3.153c-1.525-1.75-5.025-5.023-4.088-5.96s.468-1.645 2.683-.242 5.847 3.985 6.082 5.389 1.309 6.67 3.04 5.613.935-9.6.7-11.695c-.235-2.114.233-11.815-.347-14.277s-1.758-4.9-2.46-5.023-1.057.7-.7 2.572 1.872 5.6.113 3.564-4.677-4.967-3.62-5.2 1.4 2.218 1.637 0-.468-4.443.823-3.742-2.582-12.508-2.693-14.968-13.024-37.3-57.264-56.132-54.177-4.912-54.177-4.912c-.59.935-6.792 2.695-7.259 3.977s-.937 1.057-2.807 1.281c-1.87.244-6.193.935-2.685 1.179 3.508.223 14.735-2.582 19.769-3.049s7.361.468 10.636.822 11.208.468 11.208.468-1.245 2.939 1.964 2.638a6.367 6.367 0 0 1 5.07 1.339c1.057.59-1.4 1.057-.935 1.637s3.509.7 8.3 3.853 6.794 1.759 8.309 2.114-4.79.347-2.1 2.452 8.887 3.536 9.008 5.275-.71 4.585.347 5.969a41.154 41.154 0 0 1 3.153 5.951c1.29 2.563 6.08 5.258 2.114 4.9-3.986-.347-6.55-.58-4.922-1.4 1.647-.813 2.582-3.5.244-3.031s-10.412.58-11.349 1.4.468 2.807 1.283 6.662.59 5.032.122 9.588-.347 4.3.813 7.3c1.179 3 3.63 4.743 4.1 3.7s-.7-4.939 1.759-3.7 4.088 4.163 4.9 4.865 2.225 1.283 2.582 0-2.34-6.2-1.994-7.137-1.281-2.34-1.281-2.34a7.163 7.163 0 0 1-2.695-3.5c-.468-1.992-.113-1.647-1.048-3.63s-1.992-4.21-1.057-4.21 1.525.58 2.34 3.386 1.525 3.275 2.105 3.864a6.581 6.581 0 0 0 4.1 1.4c1.16-.233 1.048-3.275 2.685-2.805s-2.1 2.1-1.283 3.62 4.21 3.162 4.088 3.863-3.04-1.057-2.805.122c.233 1.16 2.225 3.5 2.805 4.323s.347 3.508-.813 3.04c-1.179-.468-1.179-3.04-1.992-.7s-.347 3.275-1.637 3.855-.235 0-1.292.59-2.685 1.283-3.5 0 0-1.87-1.057-3.04-2.1-3.162-2.218-1.759a3.839 3.839 0 0 0 .935 3.4c1.048 1.4 2.34 2.216 2.1 3.395-.223 1.16-2.45 1.283-2.805 3.855s.467 2.451-.468 3.742-.937 1.29-.937 2.45a4.532 4.532 0 0 1-1.281 2.984c-.59.533-2.1-1.346-1.75 0s1.4 1.816.225 2.161c-1.16.355-3.968.355-3.275 1.057a6.1 6.1 0 0 0 3.395 1.283c.937 0 2.1 1.758 2.807 2.805a7.315 7.315 0 0 1 .935 4.21c-.233.824-5.378 2.227-7.015 2.695s-2.573.467-2.685 1.292a9.375 9.375 0 0 0 1.16 4.555c.935 1.872-.693 2.927-.113 4.088.58 1.179 1.87 2.227 1.4 3.275s1.4-.225 3.388.59 1.29 2.46 2.927 1.525.346-1.87 1.75-2.227 2.927.468 3.049-.822 2.1-4.79 1.87-5.145c-.242-.347-1.87-.347-1.057-1.872a42.953 42.953 0 0 0 2.807-6.305c0-.59-2.1-2.927 0-3.162s1.992.468 2.807-.468 1.057-5.032 3.153-4.565c2.114.468 3.275 2.227 5.267 2.46s5.145.815 6.08 2.34-.813 4.33-.813 4.33-1.872.815-1.292 1.283 3.63.935 3.63.468-1.758-1.17-.935-1.992 1.282-3.5.935-4.088-2.46-1.283-1.29-1.75 2.573.225 2.225-.712-2.805-1.626-3.985-1.748c-1.161-.122-3.031-.235-4.088-.935s-2.34-1.17-2.572-1.994-2.1-2.927-.468-2.629 2.918 1.694 4.443 1.816 6.773 1.057 6.717 1.637-.757 1.29 1 2.227 3.275 1.983 3.742 2.918 1.292 2.807 1.759 1.292.113-3.051.225-3.986-4.557-1.983-3.275-2.685 1.758-.7 1.647-1.525-.59-3.4 1.281-1.694 3.04 4.743 4.8 4.743 1.515-.242 1.87-1.4c.348-1.179.348-1.4 1.75-1.525s.7-4.555 1.872-3.275 3.62 7.718 3.74 9.59-2.216 2.227-2.805 3.63-1.057 3.855-3.864 4.088-3.853 0-4.677 1.872.59 2.956-.113 4.985-.7 2.732-2.695 2.03-3.386.935-3.62-.345-3.153 1.983-4.677 1.628-.813-.937-2.1-1.283-.355-.785-.58-2.03c-.242-1.245-2.114-2.77-1.525-3.237s-.233-1.748-1.17-.935.235 1.057-1.983 2.114-3.517 1.076-4.677 2.058c-1.179.973-.355 1.095-2.338 1.8s-2.929.111-2.929 1.29c0 1.16-.935 1.983-2.573 3.031s-.935 1.527-2.45 1.872-2.807-.113-3.519 0c-.691.122-2.338.122-2.216 1.29s-.235 3.855-1.283 4.567c-1.057.691-1.4 0-1.87 2.338s.223 2.1.346 3.855a6.454 6.454 0 0 1-2.807 5.5c-1.87 1.048-3.2-.59-3.235 1.4s-.975 2.805-1.675 3.853-.824 1.17-.58 3.275c.223 2.1-2.695 2.452-3.162 4.677s-1.048 2.34-.355 3.742c.71 1.4 1.87 2.227 1.4 4.79-.468 2.582-1.282 3.63-1.628 5.032s1.048 3.162 1.16 4.912 2.227 1.637 3.4 3.153 3.042 1.292 3.62 2.695 2.114 1.29 3.519 2.1 1.748 2.46 5.491 1.748c3.742-.691 3.51-2.216 6.315-2.683s2.807-1.17 6.315-2.34 4.21-4.088 6.67-4.91 3.153-1.292 4.435-.7-2.1 2.805.59 1.637 2.807-3.162 5.023-2.92c2.227.225 1.179.58.712 2.807s-2.928 5.145-2.114 5.725 3.63.935 4.332 2.227-1.637 1.983-.815 3.5 1.515 1.647.347 2.34c-1.17.71-4.313 6.155-5.38 7.6s-.824 3.04 1.048 3.4 34.034-46.084 36.842-58c2.784-11.945 1.147-26.445 1.147-27.025zm-26.54-29.469c-2.582.7-.59 4.349-1.525 4.91-1.365.824-4.332 2.34-4.912-1.636s-3.853-10.292-1.515-8.777 1.741 4.454 2.8 2.227 2.695-3.162 1.525-3.275-1.534 2.1-1.525-.468-.944-5.032 0-3.63-.235 3.4 2.695 3.4 4.678-1.057 5.023 1.4-.003 5.147-2.566 5.849zm9.468-7.718c-1.833 0-1.983-3.275-4.445-3.864s-4.91-.693-5.491-3.966-1.872-7.485-.712-6.55c1.179.935 2.227 4.36 2.582 4.4s2.676 1.328 2.509.86 1.581-1.515 2.049-.355c.468 1.177.233 2.086.7 2.74s2.92 2.648 3.63 3.406c.693.752.815 3.329-.823 3.329z",
    transform: "translate(-220.408 -150.778)",
    style: {
      fill: "#bee1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2135",
    d: "M354.835 220.117c.13.346.935-2.573 3.391-3.158s3.119-.935 2.5-1.987-1.093-.586-.858-1.637-2.456-1.872-2.924-2.691-1.754-1.87-2.1-2.454-1.754-.586-1.872-1.4 1.286-2.805 0-2.805-2.338.7-2.338 0 .468-3.3-.819-1.765-.584 2.817-.584 3.635 1.519 2.689 1.4 3.04.351-1.754.7-1.052-.235 1.754.468 1.637 2.221-.118 2.338.468 1 1.519.853 1.87-1.32.7-1.2 1.053.468.584.468 1.168-.935 1.637-.468 1.756 1.942-1.17 1.2.233a5.389 5.389 0 0 0-.155 4.089z",
    transform: "translate(-193.964 -117.095)",
    style: {
      fill: "#bee1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2136",
    d: "M349.337 213.827c-1.021-.227-.351-2.221-.235-3.04s-1.4-.584-1.4-1.989 1.872-.233 1.637-1.286.584-.809 1.521-.871 1.168 1.69 1.519 2.392 1.053 1.052 0 1.987-1.988 3.042-3.042 2.807z",
    transform: "translate(-195.133 -112.793)",
    style: {
      fill: "#bee1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2137",
    d: "M366.248 221.191c-1.279-.471-1.754-2.922-1.519-3.391s2.338-1.4 2.573.586 1.169 3.624-1.054 2.805z",
    transform: "translate(-180.236 -103.552)",
    style: {
      fill: "#bee1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2138",
    d: "M323.248 185.495c-1.091-.548-3.859-2.064-2.924-2.9s3.04-2.242 2.924-.6 1.643 4.324 0 3.5z",
    transform: "translate(-219.328 -135.096)",
    style: {
      fill: "#bee1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2139",
    d: "M320.026 182.839c-1.461.417-3.282.721-3.4 0s1.052-1.891 1.989-1.891 2.737 1.512 1.411 1.891z",
    transform: "translate(-222.414 -135.343)",
    style: {
      fill: "#bee1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2140",
    d: "M362.593 184.516c-1.346 1.346-2.34.7-3.158 0s-5.847-3.51-7.6-4.561-3.624-2.6-3.508-2.879a2.323 2.323 0 0 1 2.689.657c.7 1.052 5.5 3.508 7.485 4.326s5.378 1.171 4.092 2.457z",
    transform: "translate(-194.588 -138.911)",
    style: {
      fill: "#bee1f4"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2141"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2136"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2141",
    d: "M384.081 285.909c-28.264 0-56.584-6.234-78.167-18.7-20.839-12.031-32.416-28.031-32.6-45.053l1.144-.011c.18 16.6 11.556 32.252 32.029 44.073 42.674 24.638 111.891 24.764 154.3.28 20.524-11.849 31.726-27.6 31.544-44.349l1.144-.011c.188 17.18-11.218 33.287-32.117 45.351-21.275 12.286-49.248 18.42-77.277 18.42z",
    transform: "translate(-260.427 -99.186)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2137"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2142",
    d: "M313.755 363.232c-14.917-8.326-23.132-26.127-23.132-50.119 0-48.9 34.669-108.7 77.287-133.309 19.515-11.268 38.2-13.689 52.615-6.812l-.492 1.033c-14.064-6.707-32.371-4.3-51.55 6.771-42.3 24.422-76.716 83.78-76.716 132.318 0 23.56 8.007 41 22.546 49.12z",
    transform: "translate(-245.232 -145.696)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2138"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2143",
    d: "m410.836 363.231-.558-1c14.539-8.116 22.546-25.56 22.546-49.12 0-48.538-34.415-107.9-76.716-132.318-19.181-11.073-37.487-13.477-51.55-6.771l-.492-1.033c14.414-6.874 33.1-4.456 52.615 6.812 42.616 24.6 77.286 84.407 77.286 133.309.001 23.99-8.214 41.795-23.131 50.121z",
    transform: "translate(-233.432 -145.696)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2139"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 664",
    style: {
      fill: "#fff"
    },
    d: "M0 0h1.144v218.357H0z",
    transform: "translate(122.392 13.786)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2140"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2144",
    d: "M492.989 263.718h-1.145c0-48.408-48.72-87.789-108.605-87.789s-108.605 39.38-108.605 87.789h-1.145c0-49.039 49.235-88.934 109.751-88.934s109.749 39.895 109.749 88.934z",
    transform: "translate(-260.273 -140.754)",
    style: {
      fill: "#fff"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2146"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2145"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2145",
    d: "M284.105 363.673v1.459c2.916 1.709 9.451.8 11.159 0 1.125-1.7 4.172-1.251 5.883-.575 6.535.575 8.925-.392 11.109-1.988 1.106-.809 3.089-2.918 2.85-5.154-7.777 1.785-31.001 6.258-31.001 6.258z",
    transform: "translate(57.803 193.86)",
    style: {
      fill: "#606bf1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2146",
    d: "M295.619 354.724s7.139 2.011 11.362 2.614 7.239-.1 8.243 1.408-1.206 5.429-4.925 6.736-11.362-.2-14.177.4-9.954 1.908-11.663.15 0-10.3 0-10.3z",
    transform: "translate(57.448 191.499)",
    style: {
      fill: "#56548c",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2147",
    d: "m268.986 356.844 12.772-14.3c5.092-1.455 10.45-1.759 9.768 2.942-.6 4.172-7.244 6-11.811 10.052l-4.21 3.739c-3.027 2.687-6.893.336-6.52-2.432",
    transform: "translate(44.51 179.974)",
    style: {
      fill: "#56548c",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2148",
    d: "M315.787 263.369c2.79-1.707 6.471-5.53 7.676-8.542a25.782 25.782 0 0 0 2.253-8.116 12.945 12.945 0 0 0-1.771-7.192 1.354 1.354 0 0 0-.4-.477c-.633-.411-1.378.319-1.782.958-2.278 3.617-4.321 7.657-7.177 10.84a14.569 14.569 0 0 1 1.2-3.8c.92-1.881-.684-1.816-.684-1.816-1.074.683-4.18 5.712-4.621 7.58s-1.562 6.664-1.562 6.664l.586.528c-.466.661-.772 1.067-.772 1.067s5.14 3.472 7.054 2.306z",
    transform: "translate(79.421 89.855)",
    style: {
      fill: "#ffc8af",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2149",
    d: "M273.8 258.175s-17.643 6.414-3.9 24.6z",
    transform: "translate(40.739 106.753)",
    style: {
      fill: "#112b46",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2150",
    d: "M279.2 239.392c3.793-.62 8.964-.738 12.626.344 6.161 1.82 9.528 5.757 11.015 11.6 1.5 5.892 1.94 15.715-1.433 21.189-2.109 3.423-6.805 2.779-10.161 1.889-4.056-1.076-9.361-2.824-12.688-5.337-4.632-3.5-7.083-11.163-7.366-16.7-.244-4.773 2.223-12.036 8.007-12.983",
    transform: "translate(46.457 89.855)",
    style: {
      fill: "#ffc8af",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2151",
    d: "M276.942 254.316a12.508 12.508 0 0 0 1.577 1.444 28.836 28.836 0 0 0 10.545 5.149c.646.171 1.346.323 2.066.449l-.325 3.7c-4.31 1.183-8.5-.638-11.477-1.467-2.219-.614-5.66-1.179-5.66-3.513l3.262-5.761z",
    transform: "translate(48.643 103.362)",
    style: {
      fill: "#ffc8af",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2152",
    d: "M274.493 242.484c-3.694 2.449-3.513 8.371-3.318 12.241.284 5.539 2.834 12.855 7.466 16.357 2.559 1.932 2.674 2.152 6.1 3.222a19.475 19.475 0 0 0 1.979-1.339 5.609 5.609 0 0 0 2.12-6.131c-.689-2.233-.759-4.91.505-5.6 2.064-1.129 3.442 2.879 3.442 2.879a3.059 3.059 0 0 0 2-4.193 7.1 7.1 0 0 1 0-4.88c3.658.071 5.361-4.912 6.518-5.562 2.471-1.39 3.3-1.943 2.9-4.291a7.252 7.252 0 0 0-2.032-4.131c-1.29-1.2-5.637-2.854-7.35-3.282-10.158-2.545-17.998-.732-20.33 4.71z",
    transform: "translate(46.379 87.852)",
    style: {
      fill: "#606bf1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2153",
    d: "m275.546 357.483 4.21-3.739c4.567-4.056 11.208-5.879 11.811-10.052V343.652a4.5 4.5 0 0 1-.008 1.41c-.6 4.172-7.244 6-11.811 10.052l-4.21 3.739c-3.57 3.168-7.336.909-6.52-3.786-.374 2.768 3.493 5.119 6.52 2.432",
    transform: "translate(44.469 181.766)",
    style: {
      fill: "#606bf1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2154",
    d: "M269.775 299.731c-4.409 6.244 6.617 23.526 3.6 45.042-2.045 14.592-6.033 39.087-5.079 52.909.173 2.52 10.018 4.321 12.686-7.868 4.539-20.725 10.224-33.657 12.224-49.736l-1.061-46.638z",
    transform: "translate(43.8 137.708)",
    style: {
      fill: "#717bdb",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2155",
    d: "M276.562 295.582c-1.219 19.378 12.665 43.091 11.747 58.734-.948 16.134.807 35.75.853 53.212 0 0 14.262 6.754 14.9-3.684 2.1-34.205 8.645-44.863-.193-107.451z",
    transform: "translate(51.116 139.587)",
    style: {
      fill: "#878cf0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2156",
    d: "M311.9 310.83a199.355 199.355 0 0 0-2.986-37.069 25.5 25.5 0 0 0-6.09-6.208l-4.563-5.524a163.348 163.348 0 0 1-17.067-5.184l-8.272 2.5c-6.732 2.852-8.951 11.561-5.954 20.253-.073.391 6.844 20.126 7.62 27.43.071.717-5.1 20.086-6.236 27.986 0 0 4.92 4.5 6.279 5.631 10.007 12.418 42.709-2.64 43.941-9.25.464-2.474-3.554-10.158-6.672-20.565z",
    transform: "translate(41.616 105.585)",
    style: {
      fill: "#56548c",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2157",
    d: "M289.039 293.363c-6.612.161-12.367-8.645-8.756-14.186 1.284-1.974 2.482-3.62 4.689-4.253 5.461-1.564 21.714 2.212 32.079 2.471 8.292-10.106 17.467-28.086 17.467-28.086 6.478.43 8.292 5.1 8.292 5.1-13.993 36.019-18.594 36.569-19.371 37.4s-34.329 1.552-34.4 1.554z",
    transform: "translate(53.47 98.971)",
    style: {
      fill: "#56548c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2148"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2158",
    d: "M383 362.641v1.459c-2.916 1.709-9.451.8-11.16 0-1.125-1.7-4.172-1.251-5.883-.576-6.535.576-8.925-.391-11.109-1.988-1.106-.807-3.089-2.916-2.85-5.153 7.779 1.785 31.002 6.258 31.002 6.258z",
    transform: "translate(117.382 192.955)",
    style: {
      fill: "#56548c",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2159",
    d: "M371.837 353.692s-7.139 2.011-11.362 2.614-7.239-.1-8.243 1.408 1.206 5.429 4.925 6.736 11.362-.2 14.177.4 9.954 1.908 11.663.15 0-10.305 0-10.305z",
    transform: "translate(117.388 190.594)",
    style: {
      fill: "#878cf0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2160",
    d: "m394.2 355.812-12.772-14.3c-5.092-1.457-10.45-1.759-9.768 2.942.6 4.172 7.244 6 11.811 10.052l4.21 3.737c3.027 2.687 6.893.338 6.52-2.43",
    transform: "translate(134.6 179.068)",
    style: {
      fill: "#878cf0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2161",
    d: "m387.678 356.449-4.21-3.737c-4.567-4.056-11.208-5.879-11.811-10.052V342.625a4.5 4.5 0 0 0 .007 1.41c.6 4.172 7.244 6 11.811 10.052l4.21 3.739c3.57 3.168 7.336.907 6.52-3.786.374 2.768-3.493 5.117-6.52 2.43",
    transform: "translate(134.6 180.861)",
    style: {
      fill: "#56548c",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2162",
    d: "M394.544 298.7c4.409 6.243-6.617 23.526-3.6 45.042 2.045 14.592 6.033 39.085 5.079 52.909-.173 2.52-10.018 4.321-12.686-7.868-4.539-20.725-10.224-33.657-12.224-49.736l1.061-46.638z",
    transform: "translate(134.174 136.802)",
    style: {
      fill: "#112b46",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2163",
    d: "M390.948 294.55c1.219 19.378-12.665 43.089-11.747 58.732.948 16.134-.807 35.752-.852 53.214 0 0-14.262 6.754-14.9-3.686-2.1-34.205-8.645-44.861.193-107.449z",
    transform: "translate(123.666 138.682)",
    style: {
      fill: "#112b46",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2164",
    d: "M392.117 234.23c.642-3.205.338-8.5-1.053-11.434a25.809 25.809 0 0 0-4.426-7.167 12.936 12.936 0 0 0-6.482-3.585 1.336 1.336 0 0 0-.62-.032c-.732.186-.7 1.228-.509 1.959 1.108 4.127 2.685 8.373 3.081 12.632a14.588 14.588 0 0 1-1.975-3.463c-.755-1.953-1.8-.732-1.8-.732-.229 1.252 1.35 6.948 2.422 8.542s4.615 5.6 4.615 5.6c.167.789.259 1.29.259 1.29s6.045-1.411 6.488-3.61z",
    transform: "translate(140.497 66.212)",
    style: {
      fill: "#ffc8af",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2165",
    d: "M380.07 285.7s8.964-22.741 9.584-29.926-4.85-26.762-4.85-26.762 4.745-7.058 7.969-7.719c7.827 16.474 9.939 29.888 9.939 38.7s-9.561 41.157-9.445 40.92S372.2 303.12 380.07 285.7z",
    transform: "translate(140.497 74.382)",
    style: {
      fill: "#ec827d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2166",
    d: "M364.5 309.177a199.358 199.358 0 0 1 2.986-37.069 25.5 25.5 0 0 1 6.09-6.208l8.393-4.739c3.243-.8 2.618-2.471 5.782-3.453a26.847 26.847 0 0 1 15.726-.019c6.732 2.852 8.022 7.391 5.027 16.083.073.391-1.662 22.95-2.437 30.254-.071.719.847 27.021 1.981 34.922 0 0-4.92 4.5-6.279 5.631-13.054 7.242-40.635.175-41.866-6.437-.462-2.47 1.482-18.559 4.597-28.965z",
    transform: "translate(124.274 105.302)",
    style: {
      fill: "#ec827d",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2147"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2167",
    d: "M369.733 243s-1.782 6.574-2.116 7.911a12.686 12.686 0 0 0 0 4.124c.111.89-1.45 3.342-1.226 4.456s1.226 7.8 3.342 9.693 6.016 1.226 6.016 1.226-.334 5.906 0 6.685 9.471.113 13.259-2.116 2.452-8.245 2.452-8.245L381.765 243z",
    transform: "translate(130.01 93.434)",
    style: {
      fill: "#ffc8af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2168",
    d: "M368.368 248.011s-1-4.679 0-8.022 10.027-3.008 13.2-2.005 14.374 4.679 15.043 7.353a10.7 10.7 0 0 1 0 5.014s2.173 3.679 1.838 5.851-8.356 15.542-8.356 15.542-5.091.668-6.891-.836-3.472-7.353-5.812-8.022-3.175 3.677-3.175 3.677l-1.5-1.17s.836-4.846-.167-6.518a14.812 14.812 0 0 0-2.507-3.008l1.337-5.181z",
    transform: "translate(131.374 88.424)",
    style: {
      fill: "#606bf1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2169",
    d: "M350.737 286.931c-2.984 1.339-8.221 2.218-11.385 1.512a25.755 25.755 0 0 1-7.969-2.726 12.93 12.93 0 0 1-4.935-5.522 1.372 1.372 0 0 1-.169-.6c.021-.755 1.042-.96 1.8-.93 4.27.163 8.762.76 13 .2a14.6 14.6 0 0 0-3.814-1.159c-2.071-.3-1.112-1.589-1.112-1.589 1.17-.5 7.075-.223 8.865.468l6.383 2.477.105.781c.807-.011 1.314-.034 1.314-.034s-.04 6.204-2.083 7.122z",
    transform: "translate(94.821 122.28)",
    style: {
      fill: "#ffc8af",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2170",
    d: "M402.1 277.494c3.868-5.365-.148-15.088-6.762-15.238-2.353-.054-4.39 0-6.157 1.466-4.375 3.622-10.44 19.168-16.081 27.868-13.024 1.134-33.043-1.451-33.043-1.451-3.3 5.588-.479 9.721-.479 9.721 37.626 8.8 40.68 5.314 41.806 5.143s20.668-27.449 20.716-27.509z",
    transform: "translate(105.504 110.324)",
    style: {
      fill: "#ec827d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2149",
    transform: "translate(513.307 252.246)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2171",
    d: "M390.791 205.87a7.7 7.7 0 1 0-13.589 4.965l5.887 7.045 5.919-7.045-.019-.017a7.669 7.669 0 0 0 1.802-4.948z",
    transform: "translate(-375.384 -198.166)",
    style: {
      fill: "#ec827d",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 334",
    cx: 4.07,
    cy: 4.07,
    r: 4.07,
    transform: "translate(3.634 3.634)",
    style: {
      fill: "#d16565"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2150"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2172",
    d: "M364.386 204.9a7.7 7.7 0 1 0-13.589 4.965l5.887 7.045 5.919-7.045-.021-.017a7.66 7.66 0 0 0 1.804-4.948z",
    transform: "translate(114.746 53.231)",
    style: {
      fill: "#ec827d",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2173",
    d: "M359.054 203.2a4.07 4.07 0 1 1-4.071-4.071 4.07 4.07 0 0 1 4.071 4.071z",
    transform: "translate(116.444 54.929)",
    style: {
      fill: "#d16565",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2151"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2174",
    d: "M412.5 281.6c-.321-27.872-39.974-66.593-74.438-72.688-14.194-2.509-33.065-.349-42.347 24.2l-1.1-.317c6.627-32.427 33.942-49.22 58.073-51.479 23.17-2.169 42.779 8.64 51.569 28.294 4.114-14.971 13.233-23.459 24.715-22.781 12.641.745 23.874 12.3 25.569 26.3l-1.136.137c-1.632-13.469-12.393-24.578-24.5-25.291-11.4-.67-20.156 7.905-23.954 23.54l-.419 1.716-.668-1.634c-8.24-20.15-27.8-31.311-51.065-29.139-22.035 2.062-46.771 16.457-55.383 44.046 10.2-19.431 27.522-21.07 40.845-18.712 34.9 6.17 75.056 45.485 75.382 73.8z",
    transform: "translate(67.033 39.05)",
    style: {
      fill: "#fbd15b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2152"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2175",
    d: "M306.223 215.429a7.7 7.7 0 1 0-13.589 4.965l5.887 7.043 5.919-7.043-.019-.017a7.669 7.669 0 0 0 1.802-4.948z",
    transform: "translate(63.694 62.471)",
    style: {
      fill: "#ec827d",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2176",
    d: "M300.891 213.731a4.07 4.07 0 1 1-4.071-4.071 4.07 4.07 0 0 1 4.071 4.071z",
    transform: "translate(65.392 64.169)",
    style: {
      fill: "#d16565",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2153"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2177",
    d: "M369.007 242.3a7.7 7.7 0 1 0-13.587 4.965l5.889 7.045 5.917-7.045-.019-.017a7.669 7.669 0 0 0 1.8-4.948z",
    transform: "translate(118.802 86.055)",
    style: {
      fill: "#ec827d",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2178",
    d: "M363.675 240.6a4.07 4.07 0 1 1-4.069-4.069 4.07 4.07 0 0 1 4.069 4.069z",
    transform: "translate(120.5 87.753)",
    style: {
      fill: "#d16565",
      fillRule: "evenodd"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2155"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2179",
    d: "M459.947 201.263c0 11.3-7.979 15.846-17.824 10.162S424.3 191.977 424.3 180.683s7.98-15.846 17.824-10.162 17.823 19.447 17.823 30.742z",
    transform: "translate(180.859 27.666)",
    style: {
      fill: "#bee1f4",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2180",
    d: "M454.337 196.761c0 8.872-6.268 12.446-14 7.982s-14-15.277-14-24.15 6.268-12.448 14-7.982 14 15.276 14 24.15z",
    transform: "translate(182.646 29.962)",
    style: {
      fill: "#ec827d",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": "$",
    transform: "translate(617.216 224.848)",
    style: {
      fontSize: 19,
      fontFamily: "Roboto-Bold,Roboto",
      fontWeight: 700,
      fill: "#d16565"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$")))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2181",
    d: "m469.6 397.287-72.838-42.054a11.416 11.416 0 0 1-5.708-9.886v-71.715a5.746 5.746 0 0 1 8.617-4.976l72.838 42.054a11.416 11.416 0 0 1 5.708 9.886v71.715a5.745 5.745 0 0 1-8.617 4.976z",
    transform: "translate(151.675 115.27)",
    style: {
      fillRule: "evenodd",
      fill: "#3581d8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2156"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2182",
    d: "m419.529 333.015-10.639-6.142v-28.941l10.639 6.142z",
    transform: "translate(167.334 141.65)",
    style: {
      fill: "#ec827d",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2183",
    d: "m410.607 332.978-10.639-6.142v-39.88l10.639 6.142z",
    transform: "translate(159.503 132.015)",
    style: {
      fill: "#606bf1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2184",
    d: "m428.451 352.024-10.639-6.142V287.3l10.639 6.142z",
    transform: "translate(175.166 132.314)",
    style: {
      fill: "#fbd15b",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2185",
    d: "m362.649 415.808-52.072-30.065a8.16 8.16 0 0 1-4.082-7.068v-51.27a4.107 4.107 0 0 1 6.161-3.556l52.074 30.065a8.159 8.159 0 0 1 4.08 7.068v51.27a4.107 4.107 0 0 1-6.161 3.556z",
    transform: "translate(77.455 163.911)",
    style: {
      fillRule: "evenodd",
      fill: "#3581d8"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg2);
export default __webpack_public_path__ + "static/media/img2.12b385f3ad83066e14b237da08e14fbe.svg";
export { ForwardRef as ReactComponent };